import { Box, IconButton } from '@medely/web-components';
import { Chat } from '@medely/web-components/icons';
import React from 'react';
import show from 'utils/Intercom/show';

const ChatMenu = () => {
  const handleIconClick = () => {
    show();
  };
  return (
    <IconButton onClick={handleIconClick}>
      <Box display="inline-block" position="relative" mx="auto" data-testid="chat">
        <Chat color="textPrimary" />
      </Box>
    </IconButton>
  );
};

export default ChatMenu;
